import { Quote, Star, BadgeCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { TESTIMONIALS } from "./data";
import { useSite } from "@/lib/site";

export const Testimonials = () => {
  const { content } = useSite();
  const stories = content.stories?.length ? content.stories : TESTIMONIALS;
  return (
  <section id="stories" data-testid="testimonials-section" className="py-20 sm:py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <Reveal className="max-w-2xl">
        <Eyebrow>Mothers, in their own words</Eyebrow>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-ink">
          Stories that keep us <span className="italic text-terra">going.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {stories.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <figure
              data-testid={`testimonial-${i}`}
              className="flex h-full flex-col rounded-3xl border border-ink/10 bg-white p-7 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-deep"
            >
              <Quote className="h-6 w-6 fill-terra/20 text-terra" />
              <blockquote className="mt-4 flex-1 font-display text-lg italic leading-relaxed text-ink">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 border-t border-ink/10 pt-4">
                <div className="mb-2 flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="h-3.5 w-3.5 fill-gold text-gold" />
                  ))}
                </div>
                <p className="font-outfit text-sm font-semibold text-ink">{t.name}</p>
                <p className="mt-0.5 inline-flex items-center gap-1 text-xs text-faint">
                  <BadgeCheck className="h-3 w-3 text-sage" /> {t.tag}
                </p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
